import Vue from 'vue'

export default {
  state: {
    auditingForAllProjects: [],
    auditingOrgNextCursor: null,
    auditingOrgRequestId: 0,
    securityEventsForAllProjects: [],
    securityEventsOrgNextCursor: null,
    securityEventsOrgRequestId: 0
  },
  mutations: {
    APPEND_AUDITING_ORG_LEVEL (state, { data, nextCursor }) {
      state.auditingForAllProjects = [...state.auditingForAllProjects, ...data]
      state.auditingOrgNextCursor = nextCursor || null
    },
    RESET_AUDITING_ORG (state) {
      state.auditingForAllProjects = []
      state.auditingOrgNextCursor = null
      /*
       * Bump the request id so any fetch still in flight is dropped on arrival.
       * Without this, a slow request for the previous search term appends its
       * rows on top of the cleared list and overwrites the cursor, leaving the
       * table showing results for a query the user has already replaced.
       */
      state.auditingOrgRequestId++
    },
    APPEND_SECURITY_EVENTS_ORG_LEVEL (state, { data, nextCursor }) {
      state.securityEventsForAllProjects = [...state.securityEventsForAllProjects, ...data]
      state.securityEventsOrgNextCursor = nextCursor || null
    },
    RESET_SECURITY_EVENTS_ORG (state) {
      state.securityEventsForAllProjects = []
      state.securityEventsOrgNextCursor = null
      // Bump the request id so any fetch still in flight is dropped on arrival
      // (same race as RESET_AUDITING_ORG above).
      state.securityEventsOrgRequestId++
    }
  },
  actions: {
    async LOAD_AUDITING_ORG_LEVEL ({ commit, state }, { organizationId, params = {} }) {
      const requestId = state.auditingOrgRequestId
      const cursor = state.auditingOrgNextCursor || undefined
      /*
       * The cursor already knows where the last page stopped, and it also knows
       * which time range was asked for. If we send from/to again next to it,
       * the API ignores the cursor and returns the first page again. So we send
       * from/to on the first request only.
       */
      const { from, to, ...rest } = params
      const timeWindow = cursor ? {} : { from, to }
      const result = await Vue.api.FPAPI.auditTrails.list(organizationId, {
        ...rest,
        ...timeWindow,
        cursor
      })
      if (requestId !== state.auditingOrgRequestId) return // A reset superseded this request
      commit('APPEND_AUDITING_ORG_LEVEL', result)
    },
    async LOAD_SECURITY_EVENTS_ORG_LEVEL ({ commit, state }, { organizationId, params = {} }) {
      const requestId = state.securityEventsOrgRequestId
      const cursor = state.securityEventsOrgNextCursor || undefined
      /*
       * The cursor already knows where the last page stopped, and it also knows
       * which time range was asked for. If we send from/to again next to it,
       * the API ignores the cursor and returns the first page again. So we send
       * from/to on the first request only.
       */
      const { from, to, ...rest } = params
      const timeWindow = cursor ? {} : { from, to }
      const result = await Vue.api.FPAPI.securityEvents.list(organizationId, {
        ...rest,
        ...timeWindow,
        cursor
      })
      if (requestId !== state.securityEventsOrgRequestId) return // A reset superseded this request
      commit('APPEND_SECURITY_EVENTS_ORG_LEVEL', result)
    }
  },
  getters: {
    AUDITING_FOR_ORG_LEVEL (state) {
      return state.auditingForAllProjects
    },
    AUDITING_ORG_HAS_NEXT_CURSOR (state) {
      return !!state.auditingOrgNextCursor
    },
    SECURITY_EVENTS_FOR_ORG_LEVEL (state) {
      return state.securityEventsForAllProjects
    },
    SECURITY_EVENTS_ORG_HAS_NEXT_CURSOR (state) {
      return !!state.securityEventsOrgNextCursor
    }
  }
}
